import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { MINIMUM_BET_ODD } from 'Store/constants/sportTypes';
import {
  STANDARD,
  HANDICAP_HOME,
  HANDICAP_AWAY,
  OTHER,
  LIMIT,
  EMPTY,
  INCREASE,
  DECREASE,
  BLOCK
} from 'Store/constants/sportTypes';
import { useInterval, usePrevious } from 'Utils/customHooks';

const BetPillVertical = props => {
  let verticalPill;
  const { pillType, rateChange, onClick, isSelected } = props;
  const [highlightOdd, setHighlightOdd] = useState(0);
  const prevOdd = usePrevious({ odd: props.odd });
  const loginStatus = props.loginStatus;

  useEffect(() => {
    if (prevOdd && !(prevOdd.odd === props.odd)) {
      prevOdd.odd > props.odd ? setHighlightOdd(1) : setHighlightOdd(2);
    }
  }, [props.odd]);

  useInterval(() => {
    if (highlightOdd) {
      setHighlightOdd(0);
    }
  }, 1500);

  const pillClass = classnames({
    'bet-pill bet-pill--vertical': true,
    'bet-pill--vertical--active': isSelected,
    'bet-pill--vertical--other': pillType === OTHER,
    'bet-pill--vertical--limit': pillType === LIMIT,
    'bet-pill--vertical--empty': pillType === EMPTY || props.odd === MINIMUM_BET_ODD,
    'bet-pill--increase': rateChange === INCREASE,
    'bet-pill--decrease': rateChange === DECREASE,
    'bet-pill--vertical--detail': pillType === 'detail',
    'bet-pill--inactive': pillType === HANDICAP_AWAY || pillType === HANDICAP_HOME || pillType === EMPTY || props.odd === MINIMUM_BET_ODD,
    'bet-pill--vertical--block': pillType === BLOCK,
    'bet-pill--vertical--block--active': pillType === BLOCK && isSelected,
  });

  const oddClass = classnames({
    'bet-pill__odd': true,
    'bet-pill__odd--highlight--decrease': highlightOdd === 1,
    'bet-pill__odd--highlight--increase': highlightOdd === 2
  });

  const oddValue = props.odd === MINIMUM_BET_ODD ? '-' : props.odd;

  const blurryClass = loginStatus ? '' : ' blurry-text';

  switch (pillType) {
    case STANDARD:
      verticalPill = (
        <>
          <div className={ oddClass + blurryClass }>{ oddValue }</div>
          <div className={ 'bet-pill__bet-type' + blurryClass }>{ props.betType }</div>
        </>
      );
      break;
    case HANDICAP_HOME:
      verticalPill = (
        <>
          <div className={ oddClass }>
            <div className={ 'bet-pill__odd__home' + blurryClass }>{ oddValue }</div>
            <div className="bet-pill__odd__away bet-pill__odd__away--inactive" />
          </div>
          <div className={ 'bet-pill__bet-type--handicap' + blurryClass }>{ props.betType }</div>
        </>
      );
      break;
    case HANDICAP_AWAY:
      verticalPill = (
        <>
          <div className={ oddClass }>
            <div className="bet-pill__odd__home  bet-pill__odd__home--inactive" />
            <div className={ 'bet-pill__odd__away' + blurryClass }>{ props.odd ? Math.abs(props.odd) : null }</div>
          </div>
          <div className={ 'bet-pill__bet-type--handicap' + blurryClass }>{ props.betType }</div>
        </>
      );
      break;
    case EMPTY:
      verticalPill = (
        <>
          <div className="bet-pill__odd bet-pill__odd--inactive bet-pill--inactive" />
          <div className={ 'bet-pill__bet-type' + blurryClass }>{ props.betType }</div>
        </>
      );
      break;
    case BLOCK:
      verticalPill = (
        <>
          <div className="bet-pill__label">{ props.label }</div>
          <div className="bet-pill__odd-container">
            <div className={ 'bet-pill__odd-container__odd' + blurryClass }>{ oddValue }</div>
            <div className={ 'bet-pill__odd-container__bet-type' + blurryClass }>{ props.betType }</div>
          </div>
        </>
      );
      break;
    default:
      verticalPill = (
        <>
          <div className={ oddClass + blurryClass }>{ oddValue }</div>
          <div className={ 'bet-pill__bet-type' + blurryClass }>{ props.betType }</div>
        </>
      );
      break;
  }

  return (
    <div className={ pillClass } onClick={ onClick } >
      { verticalPill }
    </div>
  );
};

BetPillVertical.propTypes = {
  pillType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  betType: PropTypes.string,
  handicap: PropTypes.string,
  className: PropTypes.string,
  odd: PropTypes.string,
  label: PropTypes.string,
  percentage: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  rateChange: PropTypes.number,
  loginStatus: PropTypes.bool
};

export default BetPillVertical;
